// import echarts from "echarts";
import * as echarts from "echarts";
export function loadChart(
  myChart,
  xData,
  cunData,
  chuData,
  name = "数量",
  unit = "头"
) {
  if (myChart) {
    myChart.clear();
  }
  if (xData.length > 0) {
    // 设置
    myChart.setOption({
      color: ["#17e0fe", "#e4b31a"],
      tooltip: {
        trigger: "item",
        padding: 1,
        formatter: "{a}" + name + "<br />{b}: {c}" + unit
        // formatter: function(param) {
        //   var resultTooltip =
        //     "<div style='background:rgba(13,5,30,.6);border:1px solid rgba(255,255,255,.2);padding:5px;border-radius:3px;'>" +
        //     "<div style='text-align:center;'>" +
        //     param.name +
        //     "</div>" +
        //     "<div style='padding-top:5px;'>" +
        //     "<span style=''> " +
        //     name +
        //     ": </span>" +
        //     "<span style=''>" +
        //     param.value +
        //     "</span><span>" +
        //     unit +
        //     "</span>" +
        //     "</div>" +
        //     "</div>";
        //   return resultTooltip;
        // }
      },
      grid: {
        top: "35%",
        left: "3%",
        right: "4%",
        bottom: 5,
        containLabel: true
      },
      legend: {
        show: true,
        icon: "circle",
        orient: "horizontal",
        top: 23,
        right: "4%",
        itemWidth: 9,
        itemHeight: 9,
        itemGap: 16,
        textStyle: {
          color: "#FFFFFF",
          fontSize: 12
        }
      },
      xAxis: [
        {
          data: xData,
          axisLabel: {
            interval: 0, // 强制显示所有标签
            //rotate: 10, //倾斜度 -90 至 90 默认为0
            textStyle: {
              color: "#fff",
              fontSize: 10
            },
            margin: 10, //刻度标签与轴线之间的距离。
            align: "center"
            // padding: [14, 0, 0, 0]
          },
          axisLine: {
            show: true, //显示x轴
            lineStyle: {
              color: "#103468",
              width: 2
            }
          },
          axisTick: {
            show: false //不显示刻度
          },
          boundaryGap: true,
          splitLine: {
            show: false,
            width: 0.08,
            lineStyle: {
              type: "solid",
              color: "#03202E"
            }
          }
        }
      ],
      yAxis: [
        {
          name: "单位：(" + unit + ")", //Y轴坐标名称 or 单位
          nameTextStyle: {
            color: "#00c0ff",
            fontSize: 12,
            // align: "left",
            padding: [0, 0, 5, 20]
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#1D4380",
              type: "solid"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true, //显示y轴
            lineStyle: {
              color: "#174d77",
              width: 1
            }
          },
          axisLabel: {
            textStyle: {
              color: "#01e4f3",
              fontSize: 12
            },
            margin: 5
          }
        }
      ],
      series: [
        //柱底圆片
        {
          name: "存栏",
          type: "pictorialBar",
          symbolSize: [20, 7],
          symbolOffset: ["-75%", 4],
          z: 12,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#184398"
                },
                {
                  offset: 1,
                  color: "#18449a"
                }
              ])
            }
          },
          data: cunData
        },

        //柱体
        {
          name: "存栏",
          type: "bar",
          barWidth: 20,
          barGap: "50%",
          label: {
            normal: {
              show: false,
              position: "top",
              fontSize: 12,
              // fontFamily: "electronicFont",
              color: "#fff"
              // offset: [-3, -5]
            }
          },
          itemStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: "linear",
                global: false,
                colorStops: [
                  {
                    //第一节下面
                    offset: 0,
                    color: "#02adf5"
                  },
                  {
                    offset: 1,
                    color: "#153a7c"
                  }
                ]
              }
            }
          },

          data: cunData
        },

        //柱顶圆片
        {
          name: "存栏",
          type: "pictorialBar",
          symbolSize: [20, 7],
          symbolOffset: ["-75%", -4],
          z: 12,
          symbolPosition: "end",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#17e1ff"
                  },
                  {
                    offset: 1,
                    color: "#10cefa"
                  }
                ],
                false
              )
            }
          },
          data: cunData
        },

        //柱底圆片
        {
          name: "出栏",
          type: "pictorialBar",
          symbolSize: [20, 7],
          symbolOffset: ["75%", 4],
          z: 12,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#684a38"
                },
                {
                  offset: 1,
                  color: "#6f4d36"
                }
              ])
            }
          },
          data: chuData
        },
        //柱体
        {
          name: "出栏",
          type: "bar",
          barWidth: 20,
          barGap: "50%",
          label: {
            normal: {
              show: false,
              position: "top",
              fontSize: 12,
              //fontFamily: "electronicFont",
              color: "#fff"
              // offset: [-3, -5]
            }
          },
          itemStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: "linear",
                global: false,
                colorStops: [
                  {
                    //第一节下面
                    offset: 0,
                    color: "#bc6e2b"
                  },
                  {
                    offset: 1,
                    color: "#443843"
                  }
                ]
              }
            }
          },

          data: chuData
        },

        //柱顶圆片
        {
          name: "出栏",
          type: "pictorialBar",
          symbolSize: [20, 7],
          symbolOffset: ["75%", -4],
          z: 12,
          symbolPosition: "end",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#e4b41a"
                  },
                  {
                    offset: 1,
                    color: "#d69c20"
                  }
                ],
                false
              )
            }
          },
          data: chuData
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
